/** Helper di formattazione e etichette della sezione Acquisti. */
export const TIPI_NOTA_CREDITO = ['TD04', 'TD08'];

export const UM_LABEL = {
  pezzo: 'pz', kg: 'kg', grammo: 'g', ettogrammo: 'hg', litro: 'l',
  confezione: 'conf.', bottiglia: 'bt', fusto: 'fusto', ora: 'ora',
  kwh: 'kWh', smc: 'smc', 'metro cubo': 'm³', 'metro quadro': 'm²', metro: 'm',
};

export const ND = 'non disponibile';

export const fmtPrezzo = (v, dec = 3) =>
  v === null || v === undefined
    ? ND
    : `${Number(v).toLocaleString('it-IT', { minimumFractionDigits: dec, maximumFractionDigits: dec })} €`;

export const fmtSoldi = (v, dec = 2) =>
  v === null || v === undefined
    ? ND
    : `${Number(v).toLocaleString('it-IT', {
      minimumFractionDigits: dec, maximumFractionDigits: dec, useGrouping: 'always',
    })} €`;

export const fmtQta = (v) =>
  v === null || v === undefined
    ? ND
    : Number(v).toLocaleString('it-IT', { maximumFractionDigits: 3 });

export const fmtUm = (umOriginale, umNorm) => {
  if (!umOriginale) return ND;
  const label = UM_LABEL[umNorm];
  return label && label.toUpperCase() !== umOriginale.trim().toUpperCase()
    ? `${umOriginale} (${label})`
    : umOriginale;
};

export const fmtDataIt = (iso) => {
  if (!iso) return ND;
  const [a, m, g] = iso.slice(0, 10).split('-');
  return `${g}/${m}/${a}`;
};

export const fmtPct = (v, dec = 1) =>
  v === null || v === undefined
    ? ND
    : `${Number(v).toLocaleString('it-IT', { minimumFractionDigits: dec, maximumFractionDigits: dec })}%`;

export const fmtVariazione = (pct) =>
  pct === null || pct === undefined
    ? null
    : `${pct > 0 ? '+' : ''}${Number(pct).toLocaleString('it-IT', { maximumFractionDigits: 1 })}%`;

/** Colore della variazione: un aumento del costo è negativo per noi. */
export const coloreVariazione = (pct) => {
  if (pct === null || pct === undefined) return 'text-muted-foreground';
  if (pct >= 10) return 'text-red-700';
  if (pct >= 5) return 'text-amber-600';
  if (pct > 0) return 'text-amber-500';
  if (pct < 0) return 'text-emerald-600';
  return 'text-muted-foreground';
};
